export enum COOKIE_ENUM {

    HST_USER_TOKEN = "hst-user-token",
    HST_USER_PROFILE_DATA = "hst-user-data",
    HST_QRCODE_LINK = "hst-qrcode-link",
    HST_LANG = "hst-language",
    HST_ID_ACCOMODATION = "hst-idAccomodation"

}